import { addToDebugData, UrlUtils } from '@wix/package-picker-shared';
import { DOWNGRADE_URLS } from '../consts';
import { parseDowngradeDetails } from './downgradeDetailsParsers';
export const getDowngradeDetailsQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    targetProductId,
    existingSubscriptionId,
    msid
  } = request;
  const url = UrlUtils.buildUrl({
    url: DOWNGRADE_URLS.getDowngradeDetails,
    params: {
      targetProductId,
      subscriptionId: existingSubscriptionId,
      msid
    }
  });
  try {
    const response = await httpClient.get(url);
    const downgradeDetails = parseDowngradeDetails(response.data.payload);
    addToDebugData({
      downgradeDetails
    });
    return {
      data: downgradeDetails,
      errorCode: response.data.errorCode,
      errorDescription: response.data.errorDescription,
      success: response.data.success
    };
  } catch (error) {
    var _axiosError$response;
    const axiosError = error;
    if ((_axiosError$response = axiosError.response) != null && _axiosError$response.data) {
      const errorData = axiosError.response.data;
      return {
        errorCode: errorData.errorCode,
        errorDescription: errorData.errorDescription,
        success: errorData.success
      };
    }
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return {
      errorCode: 500,
      errorDescription: 'Internal server error: ' + errorMessage,
      success: false
    };
  }
};
//# sourceMappingURL=getDowngradeDetails.query.js.map